import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { QueriesAPIModel, PaginatedAPI, OfflineTrackerAPIModel } from 'src/app/models/api.model'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import {
  FETCH_OFFLINE_TRACKER_DETAILS,
  save_offline_tracker_action,
  UPDATE_OFFLINE_TRACKER_ACTION
} from 'src/app/store/action/offline-tracker.action'
import { getDetails } from 'src/app/store/selector/offline-tracker.selector'

@Injectable({
  providedIn: 'root'
})
export class OfflineTrackerService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  dispatchSaveAction(offlineTracker: OfflineTrackerAPIModel, routeTo: string) {
    this.appState.dispatch(save_offline_tracker_action({ offlineTracker, routeTo }))
  }

  callSaveApi = (offlineTracker: OfflineTrackerAPIModel) => {
    const endPoint = ServiceUrlConstants.API_SAVE_OFFLINE_TRACKER
    return this.webservice
      .post(endPoint, offlineTracker, null, [], false)
      .pipe(map((data: OfflineTrackerAPIModel) => data))
  }

  dispatchFetchDetailsAction(id: string) {
    return this.appState.dispatch(FETCH_OFFLINE_TRACKER_DETAILS({ id }))
  }

  callDetailsApi = (id: string) => {
    const endPoint = `${ServiceUrlConstants.API_FETCH_OFFLINE_TRACKER}${id}`
    return this.webservice.get(endPoint).pipe(map((data: OfflineTrackerAPIModel) => data))
  }

  getDetailsFromStore = (): Observable<OfflineTrackerAPIModel> => {
    return this.appState.select(getDetails())
  }

  dispatchUpdateAction(id: string, offlineTracker: Partial<OfflineTrackerAPIModel>, routeTo: string) {
    this.appState.dispatch(UPDATE_OFFLINE_TRACKER_ACTION({ offlineTracker, id, routeTo }))
  }

  callUpdateApi = (offlineTracker: Partial<OfflineTrackerAPIModel>, id: string) => {
    const endPoint = ServiceUrlConstants.API_UPDATE_OFFLINE_TRACKER + id
    return this.webservice
      .put(endPoint, offlineTracker, null, [], false)
      .pipe(map((data: OfflineTrackerAPIModel) => data))
  }

  invokeSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_OFFLINE_TRACKER_SUMMARY_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<OfflineTrackerAPIModel>) => data))
  }
}
